import { z } from 'zod';

export const SearchParams = z.object({
    type: z.enum(['MEDICAL', 'NON_MEDICAL']).default('MEDICAL'),
    page: z.number().default(1),
    pageSize: z.number().default(100),
    search: z.string().optional(),
});

export const SearchParamsWithYear = SearchParams.extend({
    year: z.number().default(new Date().getFullYear())
});

export type SearchParams = z.infer<typeof SearchParams>;
export type SearchParamsWithYear = z.infer<typeof SearchParamsWithYear>;
